import { Grid } from "atoms";
import { ProductWizardStep } from "../ProductWizardStep";
import { WizardStepOption } from "../WizardStepOption";
import type { StepProps } from "../../types";

function StepSelectToken({ dispatch, state, moveBack }: StepProps) {
  const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  return (
    <ProductWizardStep
      stepTitle="Token"
      state={state}
      moveBack={moveBack}
      nextStep={() => dispatch({ type: "moveNext" })}
    >
      <Grid>
        {arr.map((n) => (
          <WizardStepOption
            key={n}
            groupName="token"
            type="radio"
            label={`Token ${n}`}
            image="placeholder"
          />
        ))}
      </Grid>
    </ProductWizardStep>
  );
}

StepSelectToken.displayName = "Token";

export { StepSelectToken };
